import React, { useEffect, useMemo, useState } from "react";
import { Alert, Card, CardBody, Col, Container, Input, Row, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { fmtDate, readError } from "../../helpers/whatsappTemplates";

const SOURCE = { site: "Site", chat: "Chat", email: "Email", implicit: "Implicite" };
const kpi = { background: "#fff", borderRadius: 14, padding: "14px 16px", boxShadow: "0 0 0 1px rgba(0,0,0,.05)", height: "100%" };
const chip = (on) => ({ display: "inline-flex", border: "1px solid " + (on ? "#111" : "#ddd"), borderRadius: 999, padding: "5px 11px", fontSize: 13,
    margin: "0 6px 6px 0", background: on ? "#111" : "#fff", color: on ? "#fff" : "#111", cursor: "pointer" });

// Contacts WhatsApp : audience du canal et abonnés aux bons plans (numéro toujours masqué).
export function ContactsList() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState("subscribed");
    const [market, setMarket] = useState("all");
    const [q, setQ] = useState("");

    useEffect(() => {
        apiFetch(API.back + "/whatsapp-contacts", { market: false })
            .then(async (res) => { if (!res.ok) throw new Error(await readError(res)); return res.json(); })
            .then(setData)
            .catch((e) => setError("Contacts indisponibles : " + e.message));
    }, []);

    const rows = useMemo(() => {
        if (!data) return [];
        const needle = q.trim().toLowerCase();
        return data.contacts.filter((c) => (filter === "all" || (filter === "subscribed" && c.subscribed) || (filter === "linked" && c.linkedEmail) || (filter === "optedOut" && c.optedOut))
            && (market === "all" || c.market === market)
            && (!needle || (c.name || "").toLowerCase().includes(needle) || (c.linkedEmail || "").toLowerCase().includes(needle) || (c.number || "").includes(needle)));
    }, [data, filter, market, q]);

    if (error) return <Alert color="danger">{error}</Alert>;
    if (!data) return <Spinner size="sm" />;
    const s = data.stats;
    const tiles = [
        ["Contacts", s.total, "ont écrit au numéro"],
        ["Abonnés aux bons plans", s.subscribed, `+${s.newLast7Days} sur 7 jours`],
        ["Par source", Object.keys(SOURCE).map((k) => `${SOURCE[k]} ${s.bySource[k] || 0}`).join(" · "), "accord donné depuis"],
        ["Par marché", `FR ${s.byMarket.fr || 0} · ES ${s.byMarket.es || 0}`, "abonnés"],
        ["Comptes reliés", s.linked, "compte TRC relié"],
        ["Désinscrits", s.optedOut, "STOP ou « Ne plus recevoir »"],
    ];
    return (
        <Container fluid className="p-0">
            <h1 className="h3 mb-3">Contacts WhatsApp</h1>
            <Row className="mb-3">
                {tiles.map(([l, v, sub]) => <Col key={l} md="4" lg="2" className="mb-2"><div style={kpi}><div className="small text-muted">{l}</div>
                    <div style={{ fontSize: typeof v === "number" ? 24 : 15, fontWeight: 800, lineHeight: 1.4 }}>{v}</div><div className="small text-muted">{sub}</div></div></Col>)}
            </Row>
            <Card><CardBody>
                <Row className="align-items-center mb-2">
                    <Col md="8">
                        {[["subscribed", "Abonnés"], ["all", "Tous"], ["linked", "Comptes reliés"], ["optedOut", "Désinscrits"]].map(([k, l]) => <span key={k} style={chip(filter === k)} onClick={() => setFilter(k)}>{l}</span>)}
                        <span className="mx-2 text-muted">|</span>
                        {[["all", "Tous marchés"], ["fr", "France"], ["es", "Espagne"]].map(([k, l]) => <span key={k} style={chip(market === k)} onClick={() => setMarket(k)}>{l}</span>)}
                    </Col>
                    <Col md="4"><Input bsSize="sm" placeholder="Rechercher un prénom, un email, les 2 derniers chiffres…" value={q} onChange={(e) => setQ(e.target.value)} /></Col>
                </Row>
                <div className="small text-muted mb-2">{rows.length} contact(s) · numéros masqués</div>
                <Table size="sm" hover responsive className="mb-0">
                    <thead><tr><th>Prénom</th><th>Numéro</th><th>Compte TRC</th><th>Marché</th><th>Profil</th><th>Bons plans</th><th>Dernier message</th></tr></thead>
                    <tbody>
                        {rows.map((c, i) => (
                            <tr key={i}>
                                <td>{c.name || "—"}</td>
                                <td className="text-nowrap">{c.number}</td>
                                <td>{c.linkedEmail || <span className="text-muted">—</span>}</td>
                                <td>{c.market === "es" ? "🇪🇸" : "🇫🇷"}</td>
                                <td>{[c.gender === "Men" ? "Homme" : c.gender === "Women" ? "Femme" : "", c.size ? `P. ${c.size}` : ""].filter(Boolean).join(" · ") || "—"}</td>
                                <td>{c.subscribed ? <span style={{ color: "#167a43", fontWeight: 700 }}>✓ {SOURCE[c.source] || c.source} · {fmtDate(c.subscribedAt)}</span>
                                    : c.optedOut ? <span className="text-muted">désinscrit</span> : <span className="text-muted">non</span>}
                                    {c.undeliverable && <div className="small" style={{ color: "#a50e15" }}>injoignable</div>}</td>
                                <td className="text-nowrap">{fmtDate(c.lastMessageAt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </CardBody></Card>
        </Container>
    );
}
